jQuery_T4NT(document).ready(function($){
  var interval = setInterval(function(){
    if( $('#forgot-password').length == 1 ){
      clearInterval(interval);
      $('#forgot-password').handleForgotPassword();
    }
  }, 1000);

$('#click-to-action button').click(function(){
    var t = $(this);
    var items = [];
    $('form.variations_form input[name=id]').each(function(i,e){
      items.push( $(e).val() );
    });

    t.text('ADDING ITEMS TO CART...').attr('disabled', 'disabled');
    __iterateItem();
    function __iterateItem(){
      if( items.length > 0 ){
        $.ajax({
          url: '/cart/add.js',
          type: 'POST',
          data: JSON.stringify({
            items: [
              {
                id: items[0],
                quantity: 1
              }
            ]
          }),
          dataType: 'json',
          contentType: 'application/json',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          success: function (data, status) {
            items.splice(0,1);
            __iterateItem();
          },
          error: function (data) {
            console.log(data.responseJSON);
            items.splice(0,1);
            __iterateItem();
          }
        });
      }else{
        console.log('done');
        t.text('ADD ALL TO CART').removeAttr('disabled');
        geckoShopify.onCartUpdate(1, 1);
      }
    }
    return false;
  });
});

(function($){
  $.fn.handleForgotPassword = function(){
    var __t = $(this);
    
    __t.find('input[type=submit]').click(function(){
      var xt = $(this);
      xt.attr('disabled', 'disabled');
      
      $.ajax({
        url: 'https://mobile.bites.com.my/grocery/forgot/password',
        type: 'POST',
        data: JSON.stringify({
          email: $('#RecoverEmail').val().trim()
        }),
        dataType: 'json',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        success: function (resp, status) {
          xt.removeAttr('disabled');
          geckoShopify.CreatNotices(resp.message);
        },
        error: function (data) {
          xt.removeAttr('disabled');
          geckoShopify.CreatNotices(data.statusText);
        }
      });

      return false;
    });
    
    return __t;
  }
})(jQuery_T4NT)